<div class="flex flex-row justify-between gap-4" [class]="flexWrap()">
  <div class="shrink-0">
    <div #ref (click)="openDatePickerDialog()">
      <ng-content></ng-content>
    </div>
    @if (ref && !ref?.hasChildNodes()) {
      <div class="flex flex-col">
        <span class="soft-overline">
          {{ date | format: 'DATE.DAYNAME' }}
        </span>
        <span class="font-bold pointer hover:underline" (click)="openDatePickerDialog()">
          {{ date | format: 'DATE.WITH_MONTHNAME' }}
        </span>
        <span class="text-xs text-light mt-1"> KW {{ date | format: 'DATE.WEEK' }} </span>
      </div>
    }
  </div>
  @if (headerContentTemplate(); as headerContentTemplate) {
    <ng-container *ngTemplateOutlet="headerContentTemplate"></ng-container>
  }
  <div class="flex flex-row flex-nowrap gap-4 justify-center items-center">
    <div
      class="w-8 h-8 pointer flex flex-row justify-center items-center"
      (click)="onChange(date, -1)"
    >
      <soft-icon name="fa-regular fa-chevron-left"></soft-icon>
    </div>
    <div
      class="w-8 h-8 pointer flex flex-row justify-center items-center hover:underline"
      (click)="onChange(dateService.now(), 0)"
    >
      {{ '#UI_CORE.COMPONENTS.DATE_NAVIGATOR.TODAY' | translate }}
    </div>
    <div
      class="w-8 h-8 pointer flex flex-row justify-center items-center"
      (click)="onChange(date, 1)"
    >
      <soft-icon name="fa-regular fa-chevron-right"></soft-icon>
    </div>
  </div>
</div>
